export default __webpack_public_path__ + "static/media/circle-checked-blue.8002d304.svg";